import { createSlice } from '@reduxjs/toolkit';
import { baseOnboardingUrl } from './hooks';

const initialState = {
  // Modal-specific state
  baseUrl: baseOnboardingUrl,
  
  // Stage checklist data
  stageCheckList: {
    "short": {
      "workflows": ["voip", "non-voip", "dso"],
      "description": "sentence that shows up on checklist"
    },
    "codes": {
      "workflows": ["voip", "dso"],
      "description": "these will be hard-coded in the UI"
    },
    "corresponding": {
      "workflows": ["non-voip", "dso"],
      "description": "they are just there to serve as a reference"
    }
  },
  
  // Loading and error states
  loading: false,
  error: null,
  
  // Success state
  success: false
};

const trainingWorkflowSlice = createSlice({
  name: 'trainingWorkflow',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const {
  clearError,
  clearSuccess,
  setLoading
} = trainingWorkflowSlice.actions;

// Selectors
export const selectBaseUrl = (state) => state.trainingWorkflow.baseUrl;
export const selectStageCheckList = (state) => state.trainingWorkflow.stageCheckList;
export const selectLoading = (state) => state.trainingWorkflow.loading;
export const selectError = (state) => state.trainingWorkflow.error;
export const selectSuccess = (state) => state.trainingWorkflow.success;

export default trainingWorkflowSlice.reducer;
